export default "__VITE_ASSET__sGJuNNBb__"